import { HIDE_LOADING, SHOW_LOADING, LOGIN, SET_MJB,LOGINOUT,SET_APP_FLAG, SET_RECOMMEND,SET_TOKEN_SCOKET,SET_CHANNEL,SET_PID, SET_LOGIN_OBJ ,SET_CODE,SET_USERINFO,SET_USERLIST ,TIME_OBJ} from "./types";

const state = {
  loading: false,
  token: null,
  stoken: null,
  channel:null,
  code:null,
  appflag:false,
  mjb:'hyb',
  pid:null,
  loginObj:{
    mobile:'',
    code:'',
    imgFlag:'',
  },
  recommendInfo:{
    recommendCode:'',
    recommendname:''
  },
  userInfo: {
    id:"158185761063886349",
    mobile:"18179174890",
    status:1,
    usertoken:"6cf4c04ecaeeed507785e57069cf97ae",
    viptype:"0",
    viplevel:1,
    validitydate:"2020-02-16T12:53:31.000+0000"
  }, 
  userList:[], 
  count:1,

};

//2.mutations 里面放方法 主要用于改变state里面的数据
const mutations = {
  [HIDE_LOADING](state) {
    state.loading = false;
  },
  [SHOW_LOADING](state) {
    state.loading = true;
  },
  [LOGIN](state, token) {
    state.token = token;
  },
  [LOGINOUT](state) {
    state.token = null;
  },
  [SET_RECOMMEND](state, recommendInfo) {
    state.recommendInfo = recommendInfo
  },
  [SET_TOKEN_SCOKET](state,stoken){
    state.stoken = stoken
  },
  [SET_CODE](state,code){
    state.code = code
  },
  [SET_MJB](state,mjb){
    state.mjb = mjb
  },
  [SET_CHANNEL](state,channel){
    state.channel = channel
  },
  [SET_PID](state,pid){
    state.pid = pid
  },
  
  [SET_USERINFO](state,userInfo){
    state.userInfo = userInfo
  },
  [SET_USERLIST](state,userlist){
    state.userList = userlist
  },
  [SET_LOGIN_OBJ](state,loginObj){
    state.loginObj = loginObj
  },
  [TIME_OBJ](state, timeObj){
    state.timeObj = timeObj
  },
  [SET_APP_FLAG](state, appflag){
    state.appflag = appflag
  }

}

//就是当改变state里面的count的值的时候,就会触发getters里面的方法,获取新的值。
const getters = {
  loading(state) {
    return state.loading
  },
  getRecommend(state){
    return state.recommendInfo
  },
  getUserInfo(state){
    return state.userInfo
  },
  getUserList(state){
    return state.userList
  },
  getToken(state){
    return state.token
  },
  getSToken(state){
    return state.stoken
  },
  getChannel(state){
    return state.channel
  },
  getPid(state){
    return state.pid
  },
  getCode(state){
    return state.code
  },
  getLoginObj(state){
    return state.loginObj
  },
  getAppFlag(state){
    return state.appflag;
  },
  getMjb(state){
    return state.mjb;
  }
  
}


export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/mutations.js